import { User } from '@company-box/models';

// Ported from design.component.ts's getPaperTypeID() - subcategory (not a separate
// subcategoryCode field) already holds what that method calls subcategoryCode here.
export function getPaperTypeID(paperType: string, subcategory: string): string {
  if (subcategory !== 'tape') {
    if (paperType === 'Kraft') {
      return 'k';
    } else if (paperType === 'Premium White') {
      return 'pkw';
    } else {
      return 'kw';
    }
  } else {
    return paperType === 'Kraft' ? 'k' : 'w';
  }
}

// ---- Add to Cart / Save ----
//
// Mirrors the old Unity builder's addDesignToCart()/getEffectiveUserId() (design.component.ts).
export function getEffectiveUserId(productDetails: any, user: User | undefined): number {
  if (productDetails.isRemoteAdmin) {
    return 0;
  }
  return productDetails.customerId || user?.id || 0;
}

export interface DesignRecordFields {
  user: User | undefined;
  containerID: string;
  outsideJson: string;
  insideJson: string;
  twoSided: boolean;
  insideOnly: boolean;
  productDetails: any;
  outerMaterial: string;
  innerMaterial: string;
  subcategory: string;
  luxe: boolean;
  name?: string;
}

export function buildDesignRecord(fields: DesignRecordFields): any {
  const { productDetails } = fields;
  return {
    customerId: fields.user?.shopifyId,
    container: fields.containerID,
    type: 'BASIC',
    outside: fields.outsideJson,
    inside: fields.insideJson,
    twoSided: fields.twoSided,
    insideOnly: fields.insideOnly,
    name: fields.name ?? 'Auto Saved',
    dimensions: (productDetails.BoxDimensions || '').replace(/\s/g, ''),
    subcategory: productDetails.Subcategory,
    boardType: productDetails.Code,
    boardStrength: productDetails.BoardStrength,
    kraftType: getPaperTypeID(fields.outerMaterial, fields.subcategory),
    secondarykraftType: getPaperTypeID(fields.innerMaterial, fields.subcategory),
    rush: productDetails.rush === 'true',
    preset: productDetails.Preset ? JSON.parse(productDetails.Preset) : undefined,
    gloss: productDetails.gloss === 'true',
    luxe: fields.luxe,
    quantity: productDetails.quantity,
    optionsArray: [],
    options: '',
  };
}
